import { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ILoginInfo } from "../models/ILoginInfo";
import { ensureFreshToken } from "../services/tokenRefresh";
import { getUserToken } from "../utils/Util";

/**
 * Yalnızca-garson hesaplarının menüsü: tek sayfa (Salon Siparişi) ve çıkış.
 * Yönetici menüleri, profil ve diğer sayfalar garsona hiç gösterilmez.
 */
export default function WaiterNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = getUserToken() as ILoginInfo | null;
  const name = `${user?.customerName ?? ""} ${user?.customerSurName ?? ""}`.trim();
  const initials = name.split(" ").filter(Boolean).map((w) => w[0]).join("").toUpperCase().slice(0, 2) || "G";
  const [confirmLogout, setConfirmLogout] = useState(false);

  const logout = () => {
    localStorage.removeItem("user");
    navigate("/WaiterLogin", { replace: true });
  };

  // Oturum süresi dolmuşsa ve yenilenemiyorsa garson giriş ekranına dön
  useEffect(() => {
    let cancelled = false;
    ensureFreshToken().then((ok) => {
      if (!cancelled && !ok) logout();
    });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <nav style={{
      display: "flex", alignItems: "center", gap: 12, padding: "10px 16px",
      background: "#fff", borderBottom: "1.5px solid #e5e7eb", position: "sticky", top: 0, zIndex: 1030,
    }}>
      <span style={{ fontWeight: 800, color: "#111827", fontSize: "1.02rem", whiteSpace: "nowrap" }}>
        <i className="bi bi-person-badge-fill me-2" style={{ color: "#0f766e" }}></i>Mutfacık Garson
      </span>

      <NavLink to="/garson" style={({ isActive }) => ({
        display: "inline-flex", alignItems: "center", gap: 6, padding: "7px 14px", borderRadius: 10,
        textDecoration: "none", fontWeight: 700, fontSize: "0.88rem",
        background: isActive ? "#f0fdfa" : "transparent", color: isActive ? "#0f766e" : "#4b5563",
      })}>
        <i className="bi bi-shop-window"></i>
        <span className="d-none d-sm-inline">Salon Siparişi</span>
      </NavLink>

      <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 10 }}>
        {name && (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }} title={name}>
            <span style={{
              width: 30, height: 30, borderRadius: "50%", background: "linear-gradient(135deg, #14b8a6, #0f766e)",
              color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "0.7rem", fontWeight: 800,
            }}>{initials}</span>
            <span className="d-none d-md-inline" style={{ fontSize: "0.84rem", fontWeight: 600, color: "#374151", whiteSpace: "nowrap" }}>{name}</span>
          </div>
        )}
        {confirmLogout ? (
          <div style={{ display: "flex", gap: 6 }}>
            <button onClick={logout} style={{ padding: "7px 12px", borderRadius: 10, border: "none", background: "#dc2626", color: "#fff", fontWeight: 700, fontSize: "0.82rem", cursor: "pointer" }}>
              Çıkış yap
            </button>
            <button onClick={() => setConfirmLogout(false)} style={{ padding: "7px 12px", borderRadius: 10, border: "1.5px solid #e5e7eb", background: "#fff", color: "#374151", fontWeight: 700, fontSize: "0.82rem", cursor: "pointer" }}>
              Vazgeç
            </button>
          </div>
        ) : (
          <button onClick={() => setConfirmLogout(true)} title="Çıkış"
            style={{ padding: "7px 12px", borderRadius: 10, border: "1.5px solid #fecaca", background: "#fef2f2", color: "#dc2626", fontWeight: 700, fontSize: "0.82rem", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6 }}>
            <i className="bi bi-box-arrow-right"></i><span className="d-none d-sm-inline">Çıkış</span>
          </button>
        )}
      </div>
    </nav>
  );
}
